import { render, staticRenderFns } from "./HelpPasswordRecovery.vue?vue&type=template&id=2219e334&scoped=true"
import script from "./HelpPasswordRecovery.vue?vue&type=script&lang=js"
export * from "./HelpPasswordRecovery.vue?vue&type=script&lang=js"
import style0 from "./HelpPasswordRecovery.vue?vue&type=style&index=0&id=2219e334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2219e334",
  null
  
)

export default component.exports